module.exports = __webpack_public_path__ + "img/Pl3_icon.37c43326.png";